import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg width={18} height={19} {...props}>
    <path stroke={props.fill || '#fff'} d="M5 15.05a2 2 0 1 1-4 0" />
    <circle cx={13.5} cy={15.551} r={2} stroke={props.fill || '#fff'} />
    <path
      stroke={props.fill || '#fff'}
      d="M17.5 16.55v-2.157a3 3 0 0 0-2.272-2.91L13.5 11.05m0 0-.5-2.5-3-2m3.5 4.5H10m0-4.5-1-2-2.5-.5H5m5 2.5v4.5m-9.5-7H2m5 13h2l1-2v-1.5m0 0H2m8 0v-2.5m-9.5 2.5H2m0-9.5v9.5m0-9.5h3m0 0v-2.5l-1.5-1"
    />
  </svg>
)
export default SvgComponent
